const steps = [
  {
    num: "01",
    icon: "ri-user-add-line",
    title: "회원가입",
    desc: "간단한 정보 입력으로 가입",
  },
  {
    num: "02",
    icon: "ri-coin-line",
    title: "포인트 충전",
    desc: "다양한 결제 수단 지원",
  },
  {
    num: "03",
    icon: "ri-send-plane-line",
    title: "문자 발송",
    desc: "수신자 입력 후 즉시 발송",
  },
  {
    num: "04",
    icon: "ri-bar-chart-line",
    title: "결과 확인",
    desc: "실시간 발송 결과 조회",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-[#0d0d1a] py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-violet-400 text-xs font-semibold tracking-widest uppercase mb-3 block">
            HOW IT WORKS
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white">4단계로 간편하게</h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <div key={step.num} className="relative group">
              {/* Connector line */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(100%-0px)] w-full h-px bg-gradient-to-r from-violet-500/40 to-transparent z-0 translate-x-6" />
              )}

              <div className="relative bg-white/5 border border-white/10 rounded-2xl p-8 hover:bg-white/8 hover:border-violet-500/30 transition-all duration-300 group-hover:-translate-y-1 text-center">
                {/* Step number */}
                <div className="text-6xl font-black text-white/5 absolute top-4 right-5 leading-none select-none">
                  {step.num}
                </div>

                {/* Icon */}
                <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br from-violet-600/30 to-pink-600/20 border border-violet-500/20 mx-auto mb-5">
                  <i className={`${step.icon} text-violet-400 text-2xl`}></i>
                </div>

                <h3 className="text-white font-semibold text-lg mb-2">{step.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}